import React from "react"
import { StaticQuery, graphql } from "gatsby"
import Image from "gatsby-image"

import BlockHeader from "../components/blockheader"

/*
<div
            style={{
              display: `flex`,
              marginBottom: rhythm(2.5),
            }}
          >
            <Image
              fixed={data.avatar.childImageSharp.fixed}
              alt={author}
              style={{
                marginRight: rhythm(1 / 2),
                marginBottom: 0,
                minWidth: 50,
                borderRadius: `100%`,
              }}
              imgStyle={{
                borderRadius: `50%`,
              }}
            />
            <p>
              Written by <strong>{author}</strong> who travels frequently for work and understands what it can be like to arrive somewhere new.
              {` `}
              <br/>
              I wrote <em>Landing Last Minute</em> to help the hurried traveler get necessary information about any destination.
            </p>
            
          </div>

          return (
    <StaticQuery
      query={bioQuery}
      render={data => {
        const { author, social } = data.site.siteMetadata
        return (
          <div>
            <div className="row">
              <h2 className="about-header">About Chris</h2>
            </div>
            <div className="row">
              <div
                style={{
                  display: `flex`,
                }}
                className="bio-pic"
              >
                  <Image
                    fixed={data.avatar.childImageSharp.fixed}
                    alt={author}
                    style={{
                      marginBottom: 0,
                      minWidth: 50,
                      borderRadius: `100%`,
                    }}
                    imgStyle={{
                      borderRadius: `50%`,
                    }}
                  />
              </div>
              <div className="bio">
                <p>Written by <strong>{author}</strong> who travels frequently for work and understands what it can be like to arrive somewhere new and unfamiliar.</p>
                <p>I wrote <em>Landing Last Minute</em> to help the hurried traveler get necessary information about any destination.</p>
              </div>
            </div>
          </div>
        )
      }}
    />
  )
          */

function Bio() {
  return (
    <StaticQuery
      query={bioQuery}
      render={data => {
        const { author, social } = data.site.siteMetadata
        return (
          <div className="rounded rounded-t-lg overflow-hidden shadow max-w-xs my-3">
            <BlockHeader title={"About"}/>
            <div className="flex justify-center mt-3">
              <Image
                fixed={data.avatar.childImageSharp.fixed}
                alt={author}
                className="border-solid border-white border-2 -mt-1"
              />
            </div>
            <div className="text-center px-3 pb-6 pt-2">
              <div className="mt-2 font-light text-grey-dark">
                <p>Written by <strong>{author}</strong> who travels frequently for work and understands what it can be like to arrive somewhere new and unfamiliar.</p>
                <p>I wrote <em>Landing Last Minute</em> to help the hurried traveler get necessary information about any destination.</p>
              </div>
            </div>
          </div>
        )
      }}
    />
  )
}

const bioQuery = graphql`
  query BioQuery {
    avatar: file(absolutePath: { regex: "/me_hkg__43_750.jpg/" }) {
      childImageSharp {
        fixed(width: 132, height: 86) {
          ...GatsbyImageSharpFixed
        }
      }
    }
    site {
      siteMetadata {
        author
        social {
          twitter
        }
      }
    }
  }
`

export default Bio
